export const HEAT_LOG_ACTION_TYPES = {
  SET_HEAT_DETAILS_SUCCESS: 'SET_HEAT_DETAILS_SUCCESS',
  RESET_HEAT_DETAILS: 'RESET_HEAT_DETAILS'
};
